import React from "react";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../theme/theme";
import LandingScreen from "../Screens/LandingScreen/LandingScreen";
import Header from "../components/header/Header";
import { URL_ROUTES } from "./UrlList";
import Volunteer from "../Screens/VolunteerPage/Volunteer";
import VolunteerResult from "../Screens/VolunteerPage/VolunteerResult";
import PrivacyPDF from "../Screens/privacyTerms/PrivacyPDF";
import TermsPDF from "../Screens/privacyTerms/TermsPDF";

const Root = () => (
  <ThemeProvider theme={theme}>
    <Header />
    <CssBaseline />
    <Outlet />
  </ThemeProvider>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: URL_ROUTES.LANDING_SCREEN,
        element: <LandingScreen />,
      },
      {
        path: URL_ROUTES.VOLUNTEER,
        element: <Volunteer />,
      },
      {
        path: URL_ROUTES.VOLUNTEER_RESULT,
        element: <VolunteerResult />,
      },
      {
        path: URL_ROUTES.PRIVACY,
        element: <PrivacyPDF />,
      }, {
        path: URL_ROUTES.TERMS,
        element: <TermsPDF />,
      },
    ],
    errorElement: <div>Not Found</div>,
  },
]);

function Router() {
  return <RouterProvider router={router} />;
}

export default Router;
